import React from 'react';
import Slider from "react-slick";
import bgImg from '../../assests/images/img-person.png'
import '../../assests/css/Home.css';
import imglog2 from '../../assests/images/uk_logos/e-komerco_logo_v4.png';
import imglog1 from '../../assests/images/uk_logos/feedbackcomapny.svg';
import imglog3 from '../../assests/images/uk_logos/trustpilot.svg';
import imglog4 from '../../assests/images/uk_logos/yotpo-logo-v3.svg';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import '../../assests/css/Slider_custom.css';

const Testimonial = () => {

    let arr = [{
        message: "•	I needed a taxi from Stansted Airport at 3 am. Although, I travelled frequently, my usual service declined my request, and I was getting late. I contacted Metro 24 x 7 after doing a random search. Their driver instantly came, and I recommend everyone to use the services of Metro 24 x 7 if you are looking for excellent airport transfer service. ",
        person: "Peter Smith ",
    }, {
        message: "•	I was looking for a stansted airport transfer online. Every company’s rates were too high, and I was on a tight budget. So I contacted Metro 24 x 7, and their representative suggested Minicab Stansted airport services. They charged me lesser compared to other airport rides I have ridden before. I will use their service again!",
        person: "Susan Jones ",
    },
    {
        message: "• I tried their private hire services. I needed a Taxi from Stansted Airport to take my whole family to Stansted airport. I filled out their online form, and within no time, I received a call from them. They confirmed my order, and their taxi arrived exactly at the time. They are the best All Taxis at Stansted Airport 24x7. ",
        person: "Elizabeth Webb"
    },
    {
        message: "•	I needed a taxi from Stansted Airport at 3 am. Although, I travelled frequently, my usual service declined my request, and I was getting late. I contacted Metro 24 x 7 after doing a random search. Their driver instantly came, and I recommend everyone to use the services of Metro 24 x 7 if you are looking for excellent airport transfer service. ",
        person: "Peter Smith ",
    }, {
        message: "•	I was looking for a stansted airport transfer online. Every company’s rates were too high, and I was on a tight budget. So I contacted Metro 24 x 7, and their representative suggested Minicab Stansted airport services. They charged me lesser compared to other airport rides I have ridden before. I will use their service again!",
        person: "Susan Jones ",
    },
    {
        message: "• I tried their private hire services. I needed a Taxi from Stansted Airport to take my whole family to Stansted airport. I filled out their online form, and within no time, I received a call from them. They confirmed my order, and their taxi arrived exactly at the time. They are the best All Taxis at Stansted Airport 24x7. ",
        person: "Elizabeth Webb"
    }];

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                // className={className}
                className='Slider_testimon_custom_arrows_nxt'
                // style={{ ...style, display: "block", background: "red" }}
                onClick={onClick}
            />
        );
    }

    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={"Slider_testimon_custom_arrows"}
                // "Slider_testimon_custom_arrows"
                // style={{ ...style, display: "block", background: "green" }}
                onClick={onClick}
            />
        );
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                }
            }
        ]
    };

    return (
        <div>
            <div className='container py-5'>
                <p className='red-clr f-18  mt-5 f-pop-bold'>HAPPY CUSTOMERS</p>
                <p className='blu-clr-book f-40 lh-1  f-pop-med text-dark'>SATISFIED FEEDBACK</p>
                <div className='testi_bordrodiv'>
                    <div className='row'>
                        <div className='col-sm-9'>
                            <p className='f-16 my-3 f-vis-med'>
                                Metro 24 x 7 is a reliable airport transfer services dedicated to ensuring the safety and satisfaction of our clients by offering prompt assistance and ease of booking. Whether you need immediate service to drop you at the airport or need a ride to get back to your place from the airport, you will have the leading stansted airport transfers’ full support.
                            </p>
                        </div>
                        <div className='col-sm-3'>
                        </div>
                    </div>
                </div>

                <div className='testimonial_slider mb-5'>
                    <Slider {...settings}>
                        {arr.map((item, index) => {
                            return (
                                <div key={index}>
                                    <div className='pos-rel testimonlll'>
                                        <div className='bg-review-gold-layout mt-5'>
                                            <div className="testimonial_content">
                                                {/* <p className='f-18 clr-test-rev-blu-drk mb-2'>Extremely Easy <br /></p> */}
                                                <p className='f-14 clr-test-rev-blu '>
                                                    {item.message}
                                                </p>
                                            </div>
                                        </div>
                                        {/* <div className='bg-review-red-rec showme'>
                                        </div> */}
                                        <div className='d-flex '>
                                            <div className='ps-res-testimon-review width-100 d-flex'>
                                                {/* <img className='ms-4 me-3 ms-res-img-testimon' src={bgImg} /> */}
                                                <span className='ms-4 me-3 ms-res-img-testimon'><PersonOutlineOutlinedIcon/></span> 
                                                <div className='align-self-center'>
                                                    <p className='f-14 avt-text f-vis-med'>{item.person}  </p>
                                                    {/* <p className='f-14 avt-text f-vis-med'>New York </p> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </Slider>
                </div>

                <div className='row mt-5  px-0'>
                    <div className='col-sm-3 bg-light-testimon text-center'>
                        <img src={imglog1} className="w-100 w-100-res " alt="loglipsum2" />
                    </div>
                    <div className='col-sm-3 bg-light-testimon text-center'>
                        <img src={imglog2} className="w-100 w-100-res" alt="loglipsum2" />
                    </div>
                    <div className='col-sm-3 bg-light-testimon text-center'>
                        <img src={imglog3} className="w-100 w-100-res" alt="loglipsum2" />
                    </div>
                    <div className='col-sm-3 bg-light-testimon text-center'>
                        <img src={imglog4} className="w-100 w-100-res" alt="loglipsum2" />
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Testimonial;